import { render } from "./AskFinishDialog.vue?vue&type=template&id=31a4b730"
import script from "./AskFinishDialog.vue?vue&type=script&lang=js"
export * from "./AskFinishDialog.vue?vue&type=script&lang=js"

import "./AskFinishDialog.vue?vue&type=style&index=0&id=31a4b730&lang=scss"

import exportComponent from "/Users/icesea/WebstormProjects/fpcs-h5/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__